import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";


import "react-tabs/style/react-tabs.css";
import TablaPagosVehiculos from "./tablaPagosVehiculos";
import TablaDeudasVehiculos from "./tablaDeudasVehiculos";
import TablaMultaVehiculos from "./tablaMultaVehiculos";
import { formatMoneda } from "../../../util/varios";

import { Dimmer } from '../../spinner';


export const ActualizarEstadoVehiculos = (props) => {
  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [factorCambio, setFactorCambio] = useState(0);

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const [values, setValues] = useState({
    idvehiculo: "",
    nombrepropie: "",
    cedulapropie: "",
    direccionpropie: "",
    ritm: "",
    telefonopropie: "",
    nombrerespo: "",
    cedularespo: "",
    direccionrespo: "",
    telefonorespo: "",
    serialcarroceria: "",
    serialmotor: "",
    placa: "",
    marca: "",
    modelo: "",
    anio: "",
    color: "",
    uso: "",
    numpuesto: "",
    peso: 0.0,
    capacidadcarga: 0.0,
    servicio: "",
    tipovehiculo: "",
    valorvehiculo: 0.0,
    idclasevehiculo: "",
    fechainscripcion: "",
    status: "",
  });
  const [status, setStatus] = useState();

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const imprimirRelacionPago = (reporte) => (event) => {
    event.preventDefault();

    reporte = "Planillacontricomercio";
    var cedula = values.idvehiculo;
    var tipo = "(7)";

   /*  window.open(
      op.reportes + "reporte=" + reporte + "&id=" + cedula + "&tipo=" + tipo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    ); */

    window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + cedula +  "&tipo=(7)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
   

  };

  const imprimirDeudaGeneral = (reporte) => (event) => {
    event.preventDefault();
    reporte = "Hac_DeudaGeneral";
    var rif = props.body?.rif ? props.body?.rif : values.idvehiculo;
    var cedula = values.cedulapropie ? values.cedulapropie : props.body?.cedula;

    window.open(
     op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        `&sql='${rif.trim()}'` +
        "&rif=" +
        rif.trim() +
        "&cedula=" +
        cedula +
        "&cedu2=" +
        cedula,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const salir = () => {
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setFactorCambio(props.factorCambio);
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setValues(props.vehiculo);
        setVisible(false);
        setStatus(
          props.vehiculo
            ? props.vehiculo.status == "0"
              ? "ACTIVO"
              : "INACTIVO"
            : ""
        );
      }}
    >
      <Modal.Header className="azulGradiant" style={{ height: "40px" }}>
        <div style={{ color: "#fff" }}>
          {operacion === 1
            ? "Agregar Estado Cuenta."
            : operacion === 2
            ? "Estado de Cuenta"
            : operacion === 3
            ? "Eliminar Estado Cuenta."
            : "Consultar Estado Cuenta."}
        </div>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div
          className="tipo-letra"
          style={{
            height: "auto",
            overflow: "auto",
          }}
        >
          <fieldset className=" row col-md-12 mb-2 border-azul rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto">
              Deuda Vehiculo
            </legend>

            <div class="input-group input-group-sm mb-1 col-md-2">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Código:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.idvehiculo : ""}
                id="inputCodigo"
              />
            </div>

            <div class="input-group input-group-sm mb-1 col-md-2">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                RITM:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.ritm : ""}
                id="inputCodigo"
              />
            </div>

            <div class="input-group input-group-sm mb-1 col-md-3">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Nº de Placa:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.placa : ""}
                id="inputCodigo"
              />
            </div>

            <div class="input-group input-group-sm mb-1 col-md-2">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Estatus:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={status}
                id="inputCodigo"
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-3">
              <span className="input-group-text bg-transparent fw-bold border-0">
                Valor Euro €:
              </span>
              <span className="input-group-text bg-transparent fw-bold border-0">
                {formatMoneda(
                  factorCambio.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                )}
              </span>
            </div>

            <div class="input-group input-group-sm mb-1 col-md-9">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Nombre del Propietario:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.nombrepropie : ""}
                id="inputCodigo"
              />
            </div>

            <div class="input-group input-group-sm mb-1 col-md-3">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Cedula:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.cedulapropie : ""}
                id="inputCodigo"
              />
            </div>

            <div class="input-group input-group-sm mb-1 col-md-12">
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Dirección del Propietario:
              </span>
              <input
                type="text"
                disabled={true}
                className="form-control form-control-sm "
                defaultValue={values ? values.direccionpropie : ""}
                id="inputCodigo"
              />
            </div>
          </fieldset>
          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item rounded" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Deudas del Vehiculo
              </a>
            </li>
            <li className="nav-item rounded" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="multas-tab"
                data-bs-toggle="tab"
                data-bs-target="#multas"
                type="button"
                role="tab"
                aria-controls="multas"
                aria-selected="false"
              >
                Multas
              </a>
            </li>
            <li className="nav-item rounded" role="presentation">
              <a
                className="rounded nav-link bg-blue-300 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="historico-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Historico de Pagos del Vehiculo
              </a>
            </li>
            <button
              className="btn btn-sm btn-info rounded-pill col-md-2 ml-auto"
              onClick={imprimirRelacionPago("Planillacontricomercio")}
            >
              <i className="fa fa-print"> Pagos Web</i>{" "}
            </button>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaDeudasVehiculos
                tabdeuda={props.deuda}
                idvehi={values.idvehiculo}
                ut={props.valorUt}
              />
            </div>
            <div
              className="tab-pane fade"
              id="multas"
              role="tabpanel"
              aria-labelledby="multas-tab"
            >
              <TablaMultaVehiculos tabmulta={props.multa} />
            </div>
            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="historico-tab"
            >
              <TablaPagosVehiculos
                tabpago={props.historico}
                idvehi={values.idvehiculo}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={imprimirDeudaGeneral("Hac_DeudaGeneral")}
          className="btn btn-primary btn-sm rounded-pill"
        >
          <i className="fas fa-print"> Imprimir Deuda General</i>
        </button>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-danger btn-sm rounded-pill"
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
